import { ReportingShellLoaderBaseConfig } from '../../../../base';
import { ChatComposerLoader } from './chatComposerInterface';
import { ChatComposerLoaderProps } from './chatComposerProps';
import { ChatComposerAggregate } from './chatComposerModel';

export function createChatComposerLoader(
    config: ReportingShellLoaderBaseConfig
): ChatComposerLoader {
    const {
        repository: { research: repository, assistant },
    } = config;
    return {
        useLoad(context, props): ChatComposerAggregate {
            const threadQuery = assistant.thread.useLookup(
                context,
                { id: props.thread?.id! },
                {
                    suspense: true,
                    enabled: !!props.thread?.id,
                }
            );
            return {
                thread: threadQuery.data ?? null,
            };
        },
    };
}
